import React, { useContext, useEffect, useState } from "react";
import {
  Alert,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { Btn, H3 } from "../../../AbstractElements";
import { Cancel, Save } from "../../../Shared/Constants";
import { useForm } from "react-hook-form";
import InputError from "../../../Shared/Components/Form/InputError";
import PoliticSpace from "./ContextProvider";

export default function PoliticSpaceForm() {
  //context
  const { createItem, apiErrors, modalTogle, modal, item, updateItem } =
    useContext(PoliticSpace);
  //form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm();

  const onSubmit = (data) => {
    if (item && item?.id) {
      updateItem(data, item?.id);
    } else {
      createItem(data);
    }
  };

  //set default values to form
  useEffect(() => {
    reset({
      name: item?.name,
    });
  }, [item]);

  //alert
  const [alertOpen, setAlertOpen] = useState(
    apiErrors && apiErrors.length > 0 ? true : false
  );

  const ToggleAlert = () => setAlertOpen(!alertOpen);

  //usefect
  useEffect(() => {
    setAlertOpen(apiErrors && apiErrors.length > 0 ? true : false);
  }, [apiErrors]);
  return (
    <Form onSubmit={handleSubmit(onSubmit)} id="politicSpacesForm">
      <Modal isOpen={modal} toggle={modalTogle} className="rounded-1" size="md">
        <ModalHeader toggle={modalTogle}>
          <div>
            <H3
              attrH3={{
                className: "modal-title",
                id: "exampleModalLabel1",
              }}
            >
              {item?.id ? "Modificar" : "Agregar"} espacio politico
            </H3>
          </div>
        </ModalHeader>
        <ModalBody>
          <Alert
            className="alert-dismissible"
            color="danger inverse"
            isOpen={alertOpen}
            toggle={ToggleAlert}
          >
            <i class="icon-alert"></i>
            {apiErrors && apiErrors.length > 0 ? apiErrors[0] : ""}
          </Alert>
          <div className="row g-2">
            <FormGroup className="mb-3 col-md-12">
              <Label htmlFor="name" className="form-label">
                Nombre
              </Label>
              <input
                className="form-control"
                type="text"
                required=""
                placeholder="Ingresa el nombre del espacio politico"
                autoComplete="off"
                {...register("name", {
                  required: "El nombre es obligatorio",
                })}
              />
              <InputError errors={errors} name="name" />
            </FormGroup>
          </div>

          <Btn
            attrBtn={{
              color: "secondary",
              className: "ms-1",
              onClick: modalTogle,
            }}
          >
            {Cancel}
          </Btn>
          <Btn
            attrBtn={{
              type: "submit",
              form: "politicSpacesForm",
              color: `${isDirty ? "primary" : "secondary"}`,
              disabled: !isDirty,
              className: "ms-1",
            }}
          >
            {Save}
          </Btn>
        </ModalBody>
      </Modal>
    </Form>
  );
}
